<template>
  <div class="yunxiao teacher notice-add">
    <div class="main">
      <van-form class="full-page" ref="form" input-align="right" error-message-align="right">
        <div class="example-tips">
          为防止微信官方封禁公众号，请遵守通知
          <span @click.stop="showRule">发送规范</span>
        </div>

        <van-field
          readonly
          label="接收对象"
          label-width="60px"
          class="error-color"
          :error-message="
            params.receiverRange == 1
              ? '全体学员：指校区下全部在读学员。'
              : ' 部分学员：指选择指定学员发送通知。'
          "
        >
          <template #input>
            <van-radio-group v-model="params.receiverRange" direction="horizontal">
              <van-radio :name="1">全体学员</van-radio>
              <van-radio :name="2">部分学员</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-if="params.receiverRange == 1"
          readonly
          name="picker"
          :value="campusText"
          label="校区"
          required
          :right-icon="'arrow'"
          placeholder="请选择"
          @click.stop="x3chooseCampus"
        />

        <van-cell
          title="学员"
          is-link
          @click="toChooseStudents"
          required
          v-if="params.receiverRange == 2"
        >
          <template>
            <div v-if="studentIds.length > 0" style="color: var(--g8)">
              <div class="van-ellipsis" style="color: var(--g8)">
                <span v-if="studentIds.length > 1"> 已选{{ studentIds.length }}个学员 </span>
                <span v-else>
                  {{ params.studentList[0] && params.studentList[0].name }}
                </span>
              </div>
              <!-- <span
                v-if="studentIds.length > 1"
                @click.stop="showPopup = true"
                style="color: var(--tlc); font-size: var(--fs-md)"
              >
                查看已选名单
              </span> -->
            </div>
            <div v-else style="color: var(--g5)">请选择(可多选)</div>
          </template>
        </van-cell>

        <van-field label="需家长确认" input-align="right" style="flex-wrap: wrap">
          <template #input>
            <van-switch
              v-model="params.isNeedConfirm"
              size="24"
              :active-value="1"
              :inactive-value="0"
            />
          </template>
          <template #extra>
            <div class="desc">开启后，家长端接收到的通知会增加“确认收到”操作。</div>
          </template>
        </van-field>
        <van-field
          v-model="params.title"
          label="通知标题"
          format-trigger="onBlur"
          :formatter="v => v.trim()"
          :label-width="80"
          placeholder="请输入"
          required
          maxlength="20"
          :rules="[{ required: true, message: '必填' }]"
        />
        <van-field style="display: block" required>
          <template #label>
            <span class="name">内容</span>
          </template>
          <template #input>
            <vx-mult-input v-model="params.content.list"></vx-mult-input>
          </template>
        </van-field>
      </van-form>
      <pageFooterBtn @click="submit" :loading="submiting" btnText="发送" loading-text="发送中..."/>
    </div>

    <!-- <van-action-sheet v-model="showPopup" :round="false" get-container="body">
      <div class="show-choosed-student-popup">
        <div class="head">
          <div class="til">已选学员({{ studentIds.length }})</div>
          <div class="clearbtn" @click="clearStu">清空</div>
        </div>
        <div class="linewrap">
          <div
            class="line van-hairline--bottom"
            v-for="(stu, index) in params.studentList"
            :key="stu.id"
          >
            <div class="l">
              <div class="name">{{ stu.name }}</div>
            </div>
            <div class="r"><van-icon name="clear" color="var(--g6)" @click="delStu(index)" /></div>
          </div>
        </div>
      </div>
    </van-action-sheet> -->
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'noticeAdd',
  components: {
    pageFooterBtn,
  },
  data() {
    return {
      pageTitle: '发送通知',
      // showPopup: false,
      params: {
        receiverRange: 1,
        title: '',
        campusList: [],
        studentList: [],
        content: {
          list: [
            {
              content: '',
              type: 'text',
            },
          ],
        },
        isNeedConfirm: 0,
      },
      submiting: false,
    };
  },
  computed: {
    campusText: function () {
      let cps = this.params.campusList,
        text = '';
      if (cps.length == 1) {
        text = cps[0].name;
      } else if (cps.length > 1) {
        text = `${cps.length}个校区`;
      }
      return text;
    },
    studentIds() {
      return this.params.studentList.map(item => item.id);
    },
    campusIds() {
      return this.params.campusList.map(item => item.id);
    },
  },

  methods: {
    // delStu(index){
    //   this.params.studentList.splice(index,1);
    //   if (this.params.studentList.length == 0){
    //     this.showPopup = false;
    //   }
    // },
    // clearStu() {
    //   this.params.studentList = [];
    //   this.showPopup = false;
    // },
    showRule() {
      vant.Dialog.alert({
        title: '通知发送规范',
        message:
          '1.请勿同天给同一用户多次发送同一通知内容；\n2.请勿发送涉嫌广告营销的通知，例如：红包、优惠券、代金券、会员卡、购物返利、商品降价等一系列涉及消费的广告营销类通知；\n3.不允许发送涉嫌诱导分享的通知；\n4. 若违反相应规定，将禁用通知功能。',
        confirmButtonText: '知道了',
        messageAlign: 'left',
      });
    },
    // 选择校区
    async x3chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.campusIds,
        list: this.params.campusList,
      });

      this.params.campusList = res.list;
    },
    async toChooseStudents() {
      let args = {
        ids: [...this.studentIds],
        list: this.params.studentList,
        params: {
          status: [0, 1],
        },
        defaultParams: {
          status: [0,1],
        },
        config: {
          enableMore: true,
          enableStudentStatusIds: [0,1,6,7]
        }
      };
      let ret = await app.x3.side.xsStudent(args)
      this.params.studentList = ret.list
    },
    async submit() {
      if (this.params.receiverRange == 1 && this.params.campusList.length == 0) {
        this.$toast.fail('请选择校区');
        return;
      }

      if (this.params.receiverRange == 2 && this.params.studentList.length == 0) {
        this.$toast.fail('请选择学员');
        return;
      }

      if (this.params.title.trim() === '') {
        this.$toast.fail('请输入标题');
        return;
      }

      let cont = this.params.content.list.filter(
        v => (v.type == 'text' && v.content.trim() != '') || v.type == 'image'
      );

      if (cont.length == 0) {
        this.$toast.fail('请输入内容');
        return;
      }

      this.submiting = true;

      await this.$api.sendTaskCreate({
        campusList: this.params.campusList,
        content: this.params.content,
        isNeedConfirm: this.params.isNeedConfirm,
        receiverRange: this.params.receiverRange,
        studentList: this.params.studentList,
        title: this.params.title,
      });
      this.submiting = false;
      app.vue.$emit('refresh-notice-list');
      this.$router.back();
    },
  },
  created() {
    let params = this.$route.params;
    if (params.id) {
      Object.assign(this.params, params);
    } else {
      this.params.campusList = [
        app.teacher.user.campusList.find(item => item.id == app.teacher.user.defaultCampusId),
      ];
    }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
.yunxiao.teacher.notice-add {
  .main {
    display: flex;
    flex-direction: column;
    height: 100%;
    .van-form {
      overflow-y: auto;
    }
    .error-color {
      .van-field__error-message {
        color: var(--g6);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        margin-top: calc(var(--gap) * 2);
      }
    }
    .desc {
      width: 100%;
      flex: 0 0 auto;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g6);
      margin-top: calc(var(--gap) * 4);
    }

    .example-tips {
      position: relative;
      padding: calc(var(--gap) * 8) calc(var(--w) * 16) calc(var(--gap) * 8) calc(var(--gap) * 16);
      color: var(--g6);
      span {
        color: var(--tlc);
        background-color: transparent;
      }
    }
  }
}

.show-choosed-student-popup {
  .head {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .clearbtn {
      position: absolute;
      right: calc(var(--gap) * 16);
      top: 50%;
      color: var(--tlc);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: 6px;
      transform: translate3d(0, -50%, 0);
      margin-right: -6px;
    }
  }
  .linewrap {
    padding: 0 calc(var(--gap) * 16);
    .line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: calc(var(--gap) * 8) 0;
      .l {
        .name {
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          color: var(--g8);
        }
        .desc {
          margin-top: calc(var(--gap) * 4);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--g6);
        }
      }
      .r {
        line-height: 0;
        padding: 8px;
        margin-right: -8px;
      }
    }
  }
}
</style>